export const getDateFromTime = (time: string, nowO?: Date) => {
    const now = nowO ?? new Date();
    const pairHourAndMinute = time.split(":") ?? ["0", "0"]
    const hour = Number(pairHourAndMinute[0])
    const minutes = Number(pairHourAndMinute[1])

    const returnDate = new Date(now.getFullYear(), now.getMonth(), now.getDate(), hour, minutes, 0)

    return returnDate
}